import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {
  sidenavOpened = false;

  constructor(
    private router: Router,
    public angularFireAuth: AngularFireAuth) {
  }

  login() {
    const provider = new auth.GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    this.angularFireAuth.signInWithPopup(provider);
  }

  logout() {
    this.angularFireAuth.signOut();
    this.router.navigate(['/']);
  }
}
